/**
 * Détermination du prix total à partir du prix unitaire et de la quantité
 * @param unitPrice
 * @param quantity
 * @returns
 */
export function getTotalPriceFromUnitPrice(unitPrice: number, quantity: number): number {
  return unitPrice * quantity;
}

/**
 * Détermination du prix HT à partir du prix ttc et de la tva
 * @param priceTtc
 * @param tva
 * @returns prix HT
 */
export function getPriceHtFromTtc(priceTtc: number, tva: number): number {
  const tvaPercent = 1 + (tva > 1 ? tva / 100 : tva);
  return priceTtc / tvaPercent;
}

/**
 * Détermination du montant en euro de la tva à partir du prix ttc et du pourcentage de tva
 * @param priceTtc
 * @param tva
 * @returns
 */
export function getTvaAmountFromPriceTtc(priceTtc: number, tva: number): number {
  const tvaPercent = tva > 1 ? tva / 100 : tva;
  return (priceTtc / (1 + tvaPercent)) * tvaPercent;
}

/**
 * Détermination du prix TTC à partir du prix HT et du pourcentage de tva
 * @param priceHt
 * @param tva
 * @returns
 */
export function getPriceTtcFromHtAndTva(priceHt: number, tva: number): number {
  const tvaPercent = 1 + (tva > 1 ? tva / 100 : tva);
  return priceHt * tvaPercent;
}

/**
 * Détermination du montant de TVA en euros à partir du prix HT et du pourcentage Tva
 * @param priceHt
 * @param tva
 * @returns
 */
export function getTvaAmountFromPriceHtAndTva(priceHt: number, tva: number): number {
  let percentage = tva > 1 ? 100 : 1;
  return (tva * priceHt) / percentage;
}

/**
 * Détermination du Prix remisé à partir du prix HT et du pourcentage de remise
 * @param priceHt
 * @param discount
 * @returns
 */
export function getPriceWithDiscount(price: number, discount: number): number {
  const discountPercentage = discount > 1 ? discount / 100 : discount;
  return price - price * discountPercentage;
}
